<template>
  <div class="pricing-section">
    <h2 class="pricing-title">{{ t('pricing.heading') }}</h2>
    <div class="pricing-cards">
      <!-- Immersion Plus Plan -->
      <div class="pricing-card premium-card">

        <div class="card-header">
          <h3 class="plan-name">{{ t('pricing.plan_immersion_plus') }}</h3>
        </div>
        <div class="pricing-reyals">
          <span class="pricing-start-from">ابتداء من</span>
          <div class="pricing-amount">
            <span class="pricing-currency">ريال</span>
            <span class="pricing-number">11</span>
            <span class="pricing-per-lesson">لكل درس</span>
          </div>
        </div>

        <div class="features-section">
          <p class="features-title">{{ t('pricing.enjoy_following') }}</p>
          <ul class="plan-features">
            <li class="feature-item">
              <img src="/checkmark.svg" alt="✓" class="checkmark-icon" />
              <span class="feature-name">حصص أساسية:</span>
              <span class="feature-frequency">8 شهرياً</span>
            </li>
            <li class="feature-item">
              <img src="/checkmark.svg" alt="✓" class="checkmark-icon" />
              <span class="feature-name">نادي القراءة:</span>
              <span class="feature-frequency">مرة أسبوعياً</span>
            </li>
            <li class="feature-item">
              <img src="/checkmark.svg" alt="✓" class="checkmark-icon" />
              <span class="feature-name">نادي السينما:</span>
              <span class="feature-frequency">مرة أسبوعياً</span>
            </li>
            <li class="feature-item">
              <img src="/checkmark.svg" alt="✓" class="checkmark-icon" />
              <span class="feature-name">نادي المحادثة:</span>
              <span class="feature-frequency">يومياً</span>
            </li>
            <li class="feature-item">
              <img src="/checkmark.svg" alt="✓" class="checkmark-icon" />
              <span class="feature-name">نادي المناظرات:</span>
              <span class="feature-frequency">مرة شهرياً</span>
            </li>
            <li class="feature-item">
              <img src="/checkmark.svg" alt="✓" class="checkmark-icon" />
              <span class="feature-name">نادي الصوتيات:</span>
              <span class="feature-frequency">بترشيح المعلم</span>
            </li>
            <li class="feature-item">
              <img src="/checkmark.svg" alt="✓" class="checkmark-icon" />
              <span class="feature-name">نادي لايف كوتش:</span>
              <span class="feature-frequency">جلسة مجانية</span>
            </li>
            <li class="feature-item">
              <img src="/checkmark.svg" alt="✓" class="checkmark-icon" />
              <span class="feature-name">تحدث مع أجانب:</span>
              <span class="feature-frequency">مرتين شهرياً</span>
            </li>
            <li class="feature-item">
              <img src="/checkmark.svg" alt="✓" class="checkmark-icon" />
              <span class="feature-name">اجتماع شهري مع المتدربين</span>
            </li>
            <li class="feature-item">
              <img src="/checkmark.svg" alt="✓" class="checkmark-icon" />
              <span class="feature-name">تقارير شهرية مفصل لمستوى اللغة</span>
            </li>
          </ul>
        </div>

        <CtaButton :title="t('pricing.cta_button')" :subtitle="null" class="cta-primary" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useLanguage } from '@/composables/useLanguage'
import CtaButton from '@/components/ui/CtaButton.vue'

const { t } = useLanguage()
</script>

<style scoped>
.pricing-section {
  width: 100%;
  max-width: 100vw;
  margin: 80px 0;
  padding: 60px 20px;
  box-sizing: border-box;
  background: linear-gradient(135deg, #1565a6 0%, #0d8abd 100%);
}

.pricing-title {
  font-size: clamp(28px, 5vw, 48px);
  font-weight: 700;
  color: white;
  text-align: center;
  margin-bottom: 40px;
  letter-spacing: 1px;
}

.pricing-cards {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.pricing-card {
  position: relative;
  width: 428px;
  background: white;
  border-radius: 30px;
  border: 1px solid #c5c5c5;
  padding: 60px 30px 30px;
  box-sizing: border-box;
}

.featured-card {
  width: 460px;
  margin-top: 35px;
}

.premium-card {
  width: 454px;
  border: 2px solid #f47d21;
  margin-top: 30px;
}

/* Badge styles */
.badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 232px;
  height: 145px;
  transform: translate(0, -35px);
  z-index: 10;
}

.badge-popular {
  background: url('/badge-popular.svg') no-repeat center;
  background-size: contain;
}

.badge-value {
  background: url('/badge-value.svg') no-repeat center;
  background-size: contain;
}

.badge span {
  position: absolute;
  font-family: 'Tajawal', sans-serif;
  letter-spacing: -0.02em;
  background: linear-gradient(102.99deg, #c9c9c9, #dfdfdf 0.01%, #f2f2f2 49.4%, rgba(223, 223, 223, 1));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  transform: rotate(-43.2deg);
  transform-origin: center;
}

.badge-line1 {
  top: 45px;
  right: 90px;
  font-size: 32px;
  font-weight: 500;
}

.badge-line2 {
  top: 70px;
  right: 75px;
  font-size: 48px;
  font-weight: 700;
}

/* Card header */
.card-header {
  margin-bottom: 24px;
  text-align: right;
}

.plan-name {
  font-size: 40px;
  font-weight: 700;
  color: #3d3d3d;
  margin: 0;
  display: inline-block;
}

.plan-duration {
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(-61.38deg, #115275, #ff9d52);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-right: 8px;
}

.plan-description {
  font-size: 16px;
  color: #808080;
  margin: 16px 0 0;
  text-align: right;
  line-height: 1.6;
}

/* Pricing Reyals */
.pricing-reyals {
  text-align: right;
  margin-bottom: 24px;
}

.pricing-start-from {
  display: block;
  font-size: 20px;
  font-weight: 400;
  color: #f47d21;
  margin-bottom: 8px;
}

.pricing-amount {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 8px;
  direction: rtl;
}

.pricing-number {
  font-size: 64px;
  font-weight: 700;
  color: #f47d21;
  line-height: 1;
}

.pricing-currency {
  font-size: 40px;
  font-weight: 700;
  color: #f47d21;
  line-height: 1;
}

.pricing-per-lesson {
  font-size: 20px;
  font-weight: 400;
  color: #f47d21;
}

/* Price box */
.price-box {
  background: rgba(234, 234, 234, 0.4);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1) inset;
  border-radius: 20px;
  padding: 12px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}

.total-price {
  display: flex;
  align-items: center;
  gap: 8px;
}

.price-value {
  font-size: 56px;
  font-weight: 700;
  letter-spacing: 0.6px;
  background: linear-gradient(-63.37deg, #f47d21, #ff9d52, #ff9d52);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.original-price {
  font-size: 32px;
  font-weight: 700;
  color: #808080;
  opacity: 0.7;
  text-decoration: line-through;
  position: relative;
}

.level-price-box {
  background: white;
  border: 1px solid #f47d21;
  border-radius: 20px;
  padding: 8px 16px;
  text-align: center;
}

.level-price-label {
  font-size: 12px;
  color: #f47d21;
  letter-spacing: 0.6px;
  display: block;
  margin-bottom: 8px;
}

.level-price {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.level-price-value {
  font-size: 26px;
  font-weight: 700;
  color: #f47d21;
}

.level-price-unit {
  font-size: 12px;
  color: #f47d21;
  letter-spacing: 0.6px;
}

/* Features section */
.features-section {
  margin-bottom: 24px;
}

.features-title {
  font-size: 16px;
  font-weight: 700;
  color: #3d3d3d;
  margin: 0 0 16px 0;
  text-align: right;
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 20px;
  color: #64626a;
}

.feature-item:last-child {
  border-bottom: none;
}

.checkmark-icon {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  order: 1;
}

.feature-name {
  font-weight: 400;
  color: #64626a;
  text-align: right;
  flex: 1 1 auto;
  order: 2;
  min-width: 0;
  word-wrap: break-word;
}

.feature-frequency {
  font-size: 18px;
  font-weight: 700;
  color: #f47d21;
  order: 3;
  flex-shrink: 0;
}

/* CTA Button */
:deep(.cta-button) {
  width: 100%;
  max-width: none;
  margin: 0;
}

:deep(.cta-primary .cta-button) {
  background: linear-gradient(-63.37deg, #f47d21, #ff9d52);
}

/* Responsive styles */
@media (max-width: 1400px) {
  .pricing-cards {
    gap: 20px;
  }

  .pricing-card,
  .featured-card,
  .premium-card {
    width: 100%;
    max-width: 380px;
  }
}

@media (max-width: 1200px) {
  .pricing-section {
    padding: 40px 20px;
  }

  .pricing-cards {
    flex-direction: column;
    align-items: center;
  }

  .featured-card,
  .premium-card {
    margin-top: 20px;
  }
}

@media (max-width: 768px) {
  .pricing-section {
    margin: 40px auto;
    padding: 30px 15px;
  }

  .plan-name {
    font-size: 32px;
  }

  .plan-duration {
    font-size: 20px;
  }

  .plan-description {
    font-size: 14px;
  }

  .pricing-start-from,
  .pricing-per-lesson {
    font-size: 18px;
  }

  .pricing-number {
    font-size: 52px;
  }

  .pricing-currency {
    font-size: 32px;
  }

  .price-value {
    font-size: 42px;
  }

  .original-price {
    font-size: 24px;
  }

  .feature-item {
    font-size: 16px;
  }

  .feature-frequency {
    font-size: 14px;
  }

  .badge {
    width: 180px;
    height: 112px;
    transform: translate(0, -25px);
  }

  .badge-line1 {
    font-size: 24px;
    top: 35px;
    right: 70px;
  }

  .badge-line2 {
    font-size: 36px;
    top: 55px;
    right: 60px;
  }
}

@media (max-width: 480px) {
  .pricing-card {
    padding: 50px 20px 20px;
  }

  .plan-name {
    font-size: 28px;
  }

  .pricing-start-from,
  .pricing-per-lesson {
    font-size: 16px;
  }

  .pricing-number {
    font-size: 44px;
  }

  .pricing-currency {
    font-size: 28px;
  }

  .price-value {
    font-size: 36px;
  }

  .level-price-value {
    font-size: 22px;
  }

  .feature-item {
    font-size: 14px;
    gap: 6px;
  }

  .checkmark-icon {
    width: 24px;
    height: 24px;
  }

  .cta-button {
    font-size: 16px;
    padding: 10px 20px;
  }
}
</style>
